export default __webpack_public_path__ + "static/media/banner9.b90faacc.jpeg";